import Aggregation from '../../../../types/report/Aggregation';
import AggregationFilter from '../../../../types/report/AggregationFilter';
import StatementHelper from '../../../types/Functions/StatementHelper';

class AggregationFilterHelper extends StatementHelper<AggregationFilter> {

    constructor(private aggregation: Aggregation)
    {
        super();
    }

    getDataSourceId(filter: AggregationFilter, dataSourceId: number | null): number | null {

        return filter.dataSourceId;
    }

    getEmpty(dataSourceId: number | null): AggregationFilter {

        return {
            id: null,
            dataSourceId: this.aggregation.dataSourceId,
            number: 0,
            condition: null as any,
            name: '',
            businessDescription: '',
            isBespoke: false,
            bespokeCondition: '',
            errors: [],
            lastUpdatedTime: undefined,
            _internalId: undefined as any
        };
    }
}

const aggregationFilterHelper = (agg: Aggregation): AggregationFilterHelper => new AggregationFilterHelper(agg);


export default aggregationFilterHelper;
